import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Circle,
  Flex,
  Grid,
  Heading,
  HStack,
  Text,
  useColorModeValue,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import SaveConfirmationModal from "../Components/SaveConfirmationModal";
import SelectCompanyLogo from "../Components/SelectCompanyLogo";
import MyInput from "../../../../../components/formComponents/MyInput";
import SelectInput from "../../../../../components/formComponents/SelectInput";
import MySelect from "../../../../../components/formComponents/MySelect";
import MultiImageUpload from "../Components/MultiImageUpload";
import UploadFileStyleTwo from "../Components/UploadFileStyleTwo";
import FloorMapUpload from "../Components/FloorMapUpload";
import ImgUploadDesignLib from "./ImgUploadDesignLib";
import { set } from "react-hook-form";
import ImgGrid, { ActiveImg } from "./ImgGrid";
import {
  getAxiosConfig,
  getDesignBgImage,
  getImageUrls,
  getMinioImage,
} from "../../../../../utils/helpers";
import DeleteIcon from "../../../../../components/DeleteIcon";
import axios from "axios";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { designStyle } from "../../../../../utils/options";
import { useFormContext } from "../FormStateContext";
import Img from "../../../../../components/Img";
import { MAX_COMPANY_NAME_LENGTH } from "../../../../../utils/constant";
import PopupWrapper from "../../../../../components/PopupWrapper";
import TestViewButton from "../../../../../components/TestViewButton";
import ViewLayoutBtn from "../../../../../components/ViewLayoutBtn";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableItem({ id, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div
        {...attributes}
        {...listeners}
        className="absolute right-16 top-[10px] z-[2] cursor-grab flex items-center gap-1 bg-teal-50 hover:bg-teal-100 text-teal-700 px-2 py-1 rounded-md border border-teal-200 text-xs font-medium select-none shadow-sm transition-all active:cursor-grabbing"
      >
        <Icon icon="icon-park-outline:drag" className="w-3.5 h-3.5" />
        <span>Reorder</span>
      </div>
      {children}
    </div>
  );
}

const colors = [
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
];

const areaOptions = [
  // Work Spaces
  "Materials",
  "open-office",
  "private-office",
  // "boss-cabin",
  "work-lounge",

  // Meeting Spaces
  "assembly",
  "boardroom",
  "brainstorm-room",
  "breakout-space",
  "large-meeting-room",
  "large-open-meeting-space",
  "small-meeting-room",
  "small-open-meeting-space",
  "training-room",

  // Support Spaces
  "bar",
  "cafeteria",
  "elevator-lobby",
  "games-room",
  "locker-area",
  "pantry-area",
  "phone-study-booth",
  "reception-waiting-area",
  "restroom",
];

function PlanLayout({
  setActiveTab,
  data,
  isEdit,
  isRandom,
  handlePublicLink,
  storeActiveTab,
  allVersions = [],
  onVersionChange,
}) {
  const area = {
    area: "",
    colorPalette: [],
    areaImage: [],
    areaImageSelection: [],
    designLibraryImages: [],
    designStyle: "Warm Industrial",
    selection1: {},
    selection2: {},
    selection3: {},
    selection4: {},
    designBg: "background 1",

    keyPlan: {},
    selectedKeyPlanIdx: null,
    order: [],
  };

  const initialValues = {
    companyLogo: [],
    companyName: "",
    layouts: [
      {
        floorMap: null,
        selection1: {},
        selection2: {},
        selection3: {},
        selection4: {},
        legend: [{ key: "", value: "" }],
      },
    ],
    areas: [{ ...area }],
  };
  const nav = useNavigate();
  const { setData, FORMDATA } = useFormContext();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pendingFormData, setPendingFormData] = useState(null);
  // const [internalView, setInternalview] = useState(null)
  const [formvalues, setFormValues] = useState(() => {
    const baseValues = FORMDATA ? FORMDATA : initialValues;
    const areasWithId = (baseValues.areas || []).map((area, idx) => ({
      ...area,
      dragId:
        area.dragId ||
        area._id ||
        `area-${Date.now()}-${idx}-${Math.random().toString(36).substr(2, 5)}`,
    }));
    return { ...baseValues, areas: areasWithId };
  });
  const [accControl, setAccControl] = useState([0]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      setFormValues((prev) => {
        const oldIndex = prev.areas.findIndex(
          (item) => item.dragId === active.id,
        );
        const newIndex = prev.areas.findIndex(
          (item) => item.dragId === over.id,
        );

        const newAreas = arrayMove(prev.areas, oldIndex, newIndex);

        setAccControl((prevAcc) => {
          return prevAcc.map((idx) => {
            if (idx === oldIndex) return newIndex;
            if (oldIndex < newIndex) {
              if (idx > oldIndex && idx <= newIndex) return idx - 1;
            } else {
              if (idx >= newIndex && idx < oldIndex) return idx + 1;
            }
            return idx;
          });
        });

        return {
          ...prev,
          areas: newAreas,
        };
      });
    }
  }
  console.log("Form Values", formvalues);
  const [loading, setLoading] = useState(false);
  const { projectData, basicInfo } = useOutletContext() || {
    projectData: {},
    basicInfo: {},
  };

  function chkValidation(isHideToast) {
    let isValid = true;
    if (!formvalues?.companyLogo || formvalues?.companyLogo?.length == 0) {
      !isHideToast && toast.error("Please select a company logo");
      return false;
    }
    if (!formvalues?.companyName || formvalues?.companyName?.length == 0) {
      !isHideToast && toast.error("Please enter a company name");
      return false;
    }
    if (
      formvalues?.companyName &&
      formvalues?.companyName.length > MAX_COMPANY_NAME_LENGTH
    ) {
      !isHideToast &&
        toast.error(
          `Please enter a company name less than ${MAX_COMPANY_NAME_LENGTH} characters`,
        );
      return false;
    }
    // if (!formvalues?.floorMap || formvalues?.floorMap?.length == 0) {
    //   !isHideToast && toast.error("Please upload a floor map");
    //   return false;
    // }
    if (formvalues?.areas?.length == 0) {
      !isHideToast && toast.error("Please add at least one area");
      return false;
    }
    // if(isRandom && ( !formvalues?.designStyle ||  formvalues?.designStyle == "")){
    //   !isHideToast && toast.error("Design style is required");
    //   return false;
    // }
    formvalues?.areas?.forEach((area, idx) => {
      if (!area?.area || area?.area?.length == 0) {
        !isHideToast && toast.error(`Please enter a name for Area ${idx + 1}`);
        isValid = false;
        return false;
      }
      if (!area?.designStyle || area?.designStyle?.length == 0) {
        !isHideToast &&
          toast.error(`Please select a design style for Area ${idx + 1}`);
        isValid = false;
        return false;
      }
      // if (!area?.keyPlan || Object.keys(area?.keyPlan)?.length == 0) {
      //   !isHideToast &&
      //     toast.error(`Please select a key plan for Area ${idx + 1}`);
      //   isValid = false;

      //   return false;
      // }
      if (
        area?.designLibraryImages?.length == 0 &&
        area?.areaImage?.length == 0
      ) {
        !isHideToast &&
          toast.error(`Please upload at least one image for Area ${idx + 1}`);
        isValid = false;

        return false;
      }
    });
    return isValid;
  }
  async function handleSubmitForm() {
    console.log("Submitting form with values:", formvalues);
    if (!chkValidation()) {
      console.log("Validation failed");
      return;
    }
    const formdata = new FormData();
    formdata.append("companyLogo", formvalues.companyLogo?.[0]);
    formdata.append("companyName", formvalues.companyName);

    // Extract floorMaps array from layouts
    const floorMaps = (formvalues.layouts || []).map(
      (layout) => layout.floorMap,
    );
    floorMaps.forEach((floorMap, idx) => {
      if (floorMap) {
        formdata.append(`floorMap_${idx}`, floorMap);
      }
    });

    // Create layouts array without floorMap key
    const layoutsWithoutFloorMap = (formvalues.layouts || []).map((layout) => ({
      selection1: layout.selection1 || {},
      selection2: layout.selection2 || {},
      selection3: layout.selection3 || {},
      selection4: layout.selection4 || {},
      legend: layout.legend || [],
      ...(layout?.floorMap instanceof Blob || layout.floorMap instanceof File
        ? {}
        : { floorMap: layout.floorMap }),
    }));
    formdata.append("layouts", JSON.stringify(layoutsWithoutFloorMap));

    formdata.append(
      "projectId",
      isRandom ? "6826fe28f13d9ed89b2a732c" : projectData?._id,
    );
    formdata.append("type", isRandom ? "internal" : "");
    // formdata.append("designStyle", isRandom ? formvalues.designStyle : "");

    formvalues.areas.forEach((area, idx) => {
      area?.areaImage
        ?.filter((f) => f instanceof File || f instanceof Blob)
        .forEach((file) => {
          formdata.append(`image_${idx}`, file);
        });
    });
    let NewAreas = formvalues.areas.map((area, idx) => {
      return {
        area: area.area,
        internalImages: area?.designLibraryImages,
        keyPlan: area?.keyPlan,
        selectedKeyPlanIdx: area.selectedKeyPlanIdx,
        areaImageSelection: area?.areaImageSelection,
        designStyle: area?.designStyle || "",
        designBg: area?.designBg || "background 1",
        order: area?.order || [],
        selection1: area?.selection1 || {},
        selection2: area?.selection2 || {},
        selection3: area?.selection3 || {},
        selection4: area?.selection4 || {},
        areaImage: area?.areaImage?.filter(
          (v) => !(v instanceof File || v instanceof Blob),
        ),
      };
    });
    formdata.append("areas", JSON.stringify(NewAreas));
    console.log("Form Data to be submitted", formdata);
    // return;

    if (isEdit) {
      setPendingFormData(formdata);
      onOpen();
    } else {
      executeSubmit(false, formdata);
    }
  }

  async function executeSubmit(saveAsNew, fd = pendingFormData) {
    if (!fd) return;

    if (saveAsNew && isEdit) {
      const latestVersionId =
        allVersions.length > 0 ? allVersions[0]._id : isEdit;
      fd.append("parentVersionId", latestVersionId);
    }

    setLoading(true);
    try {
      if (isEdit && !saveAsNew) {
        const { data } = await axios.put(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/add-concept-board/${isEdit}`,
          fd,
          getAxiosConfig({}, true),
        );
        console.log("AFTER EDIT", data);
        handlePublicLink(
          `conceptual/${data?.data?._id}/${
            isRandom ? data?.data?.companyName : projectData?.title
          }`,
        );
        toast.success("Conceptual Mood Board updated successfully");
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/add-concept-board`,
          fd,
          getAxiosConfig({}, true),
        );
        console.log("AFTER ADD", data);
        handlePublicLink(
          `conceptual/${data?.data?._id}/${
            isRandom ? data?.data?.companyName : projectData?.title
          }`,
        );

        toast.success(
          saveAsNew
            ? "Conceptual Mood Board saved as new version successfully"
            : "Conceptual Mood Board created successfully",
        );
      }
      setActiveTab();
      onClose();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to save Conceptual Mood Board");
    } finally {
      setLoading(false);
      setPendingFormData(null);
    }
  }

  useEffect(() => {
    if (FORMDATA) return;
    if (isEdit) {
      console.log("IS EDIT", isEdit, data);
      const presentation = data.find((i) => i?._id == isEdit);
      if (presentation) {
        console.log("Presentation Data", presentation);
        setFormValues((prev) => ({
          ...prev,
          // designStyle: presentation?.designStyle || "",
          companyLogo: presentation?.companyLogo
            ? presentation?.companyLogo
            : [],
          companyName: presentation?.companyName || "",
          layouts: presentation?.layouts || [
            {
              floorMap: presentation?.floorMap || null,
              selection1:
                typeof presentation?.selection1 == "string"
                  ? JSON.parse(presentation?.selection1)
                  : presentation?.selection1 || {},
              selection2:
                typeof presentation?.selection2 == "string"
                  ? JSON.parse(presentation?.selection2)
                  : presentation?.selection2 || {},
              legend: presentation?.legend || [],
            },
          ],
          areas: presentation?.areas?.map((area, idx) => ({
            ...area,
            dragId:
              area.dragId ||
              area._id ||
              `area-edit-${Date.now()}-${idx}-${Math.random().toString(36).substr(2, 5)}`,
            areaImage: area?.areaImage,
            designLibraryImages: area?.internalImages,
          })),
        }));
      }
    }
  }, [isEdit]);
  useEffect(() => {
    if (FORMDATA) return;
    if (isRandom) return;

    setFormValues((p) => ({
      ...p,
      companyLogo: basicInfo?.companyLogo || [],
      companyName: basicInfo?.companyName || "",
      // layouts: basicInfo?.layouts || [
      //   {
      //     floorMap: basicInfo?.floorMap || null,
      //     selection1:
      //       typeof basicInfo?.selection1 == "string"
      //         ? JSON.parse(basicInfo?.selection1)
      //         : basicInfo?.selection1 || {},
      //     selection2:
      //       typeof basicInfo?.selection2 == "string"
      //         ? JSON.parse(basicInfo?.selection2)
      //         : basicInfo?.selection2 || {},
      //     legend: basicInfo?.legend || [],
      //   },
      // ],

      // designStyle: basicInfo?.designStyle || "",
    }));
  }, []);

  const handleAddArea = () => {
    setFormValues((v) => ({
      ...v,
      areas: [
        ...v.areas,
        {
          ...area,
          dragId: `area-new-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
          designStyle:
            v.areas?.length > 0 && v.areas[0].designStyle
              ? v.areas[v.areas.length - 1].designStyle
              : "Warm Industrial",
        },
      ],
    }));
    setAccControl([formvalues.areas.length]);
  };

  const handleAddAreaBelow = (targetIdx) => {
    const newArea = {
      ...area,
      dragId: `area-new-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
      designStyle:
        formvalues.areas?.length > 0 && formvalues.areas[targetIdx]?.designStyle
          ? formvalues.areas[targetIdx].designStyle
          : "Warm Industrial",
    };

    setFormValues((v) => {
      const updatedAreas = [...v.areas];
      updatedAreas.splice(targetIdx + 1, 0, newArea);
      return {
        ...v,
        areas: updatedAreas,
      };
    });
    setAccControl([targetIdx + 1]);
  };

  console.log("DESIGN STYLE", formvalues);
  return (
    <Box>
      {isEdit && allVersions.length > 1 && (
        <div className="flex items-center gap-2 flex-wrap px-4 py-3 mb-2 bg-white border border-teal-100 rounded-xl shadow-sm">
          <span className="text-xs font-semibold text-gray-500 mr-1 uppercase tracking-wide">
            Versions
          </span>
          {allVersions.map((v) => {
            const isActive = v._id === isEdit;
            return (
              <button
                key={v._id}
                onClick={() => {
                  if (!isActive && onVersionChange) onVersionChange(v._id);
                }}
                className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium transition-all border ${
                  isActive
                    ? "bg-teal-600 text-white border-teal-600 shadow-md scale-105"
                    : "bg-white text-teal-700 border-teal-300 hover:bg-teal-50 hover:border-teal-500"
                }`}
              >
                <span>v{v.version || 1}</span>
                {v.createdAt && (
                  <span
                    className={`text-[10px] ${
                      isActive ? "text-teal-100" : "text-gray-400"
                    }`}
                  >
                    ·{" "}
                    {new Date(v.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                    })}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
      <Box display={"flex"} flexDir={"column"} width={"100%"}>
        <div className="grid grid-cols-2 p-4 flex-1 ">
          <SelectCompanyLogo
            image={formvalues.companyLogo?.[0]}
            isViewOnly={!isRandom}
            setImage={(i) => {
              console.log("Company Logo", i);
              setFormValues((v) => ({ ...v, companyLogo: [i] }));
            }}
          />
          <MyInput
            required={true}
            readOnly={!isRandom}
            placeholder={"Type here Company Name"}
            label={"Company Name"}
            value={formvalues.companyName}
            error={
              formvalues.companyName?.length > MAX_COMPANY_NAME_LENGTH
                ? `Company name should be less than ${MAX_COMPANY_NAME_LENGTH} characters`
                : false
            }
            onChange={(e) =>
              setFormValues((v) => ({ ...v, companyName: e.target.value }))
            }
          />
        </div>
        <Box flex={1} p={4} bgColor={"#fafafa"} rounded={"xl"} shadow={"sm"}>
          <div className="flex items-center justify-between">
            <h2 className="text-center text-xl text-teal-600">Floor Map</h2>
            {/* <Button 
              size={'sm'}
              onClick={() => {
                setFormValues((prev) => ({
                  ...prev,
                  layouts: [...(prev.layouts || []), {
                    floorMap: null,
                    selection1: {},
                    selection2: {},
                    legend: []
                  }]
                }));
              }}
            >
              <Icon className="mr-2" icon={"mdi:plus"} />  Add Layout
            </Button> */}
          </div>
          {/* Multiple Layouts Display */}
          {(formvalues.layouts || []).map((layout, layoutIdx) => (
            <div
              key={layoutIdx}
              className="mt-8 p-6 bg-white border-2 border-teal-200 rounded-lg"
            >
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-teal-700">
                  Layout {layoutIdx + 1}
                </h3>
                {formvalues.layouts.length > 1 && (
                  <button
                    onClick={() => {
                      const layoutIndexToDelete = layoutIdx;
                      setFormValues((prev) => {
                        const newLayouts = (prev.layouts || []).filter(
                          (_, i) => i !== layoutIndexToDelete,
                        );

                        // Update areas: if any area referenced this layout index, clear it;
                        // if index is greater than deleted index, shift it left by 1
                        const updatedAreas = (prev.areas || []).map((a) => {
                          const idx = a?.selectedKeyPlanIdx;
                          if (idx === layoutIndexToDelete) {
                            return {
                              ...a,
                              selectedKeyPlanIdx: null,
                              keyPlan: {},
                            };
                          }
                          if (
                            typeof idx === "number" &&
                            idx > layoutIndexToDelete
                          ) {
                            return { ...a, selectedKeyPlanIdx: idx - 1 };
                          }
                          return a;
                        });

                        return {
                          ...prev,
                          layouts: newLayouts,
                          areas: updatedAreas,
                        };
                      });
                    }}
                    className="flex items-center gap-2 px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
                  >
                    <Icon icon="mdi:delete" width="20" height="20" />
                    Delete
                  </button>
                )}
              </div>

              <div className="grid grid-cols-2 gap-4">
                {/* Floor Map Upload */}
                <div>
                  <Box>
                    <h4 className="text-sm font-medium text-gray-700 mb-2">
                      Floor Map
                    </h4>
                    <UploadFileStyleTwo
                      label={""}
                      isViewOnly={false}
                      key={`floormap-${layoutIdx}`}
                      multiple={false}
                      file={layout?.floorMap || []}
                      setFile={(val) => {
                        console.log("Floor Map", layoutIdx, [...val]);
                        setFormValues((v) => {
                          const newLayouts = [...(v.layouts || [])];
                          newLayouts[layoutIdx] = {
                            ...newLayouts[layoutIdx],
                            floorMap: val[0] || null,
                            selection1: {},
                            selection2: {},
                            selection3: {},
                            selection4: {},
                          };
                          // If floor map removed (val[0] falsy), clear any area references
                          // that were pointing to this layout index. Otherwise leave areas as-is.
                          const updatedAreas = (v.areas || []).map((a) => {
                            if (
                              !val[0] &&
                              a?.selectedKeyPlanIdx === layoutIdx
                            ) {
                              return {
                                ...a,
                                selectedKeyPlanIdx: null,
                                keyPlan: {},
                              };
                            }
                            return a;
                          });

                          return {
                            ...v,
                            layouts: newLayouts,
                            areas: updatedAreas,
                          };
                        });
                      }}
                    />
                  </Box>

                  {/* Selection 1, 2, 3 and 4 */}
                  <Flex mt={2} justify={"space-between"} gap={2} wrap={"wrap"}>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap || ""}
                        coordinates={layout?.selection1 || {}}
                        onSelectArea={(coordinates) => {
                          setFormValues((v) => {
                            const newLayouts = [...(v.layouts || [])];
                            newLayouts[layoutIdx] = {
                              ...newLayouts[layoutIdx],
                              selection1: coordinates,
                            };
                            return { ...v, layouts: newLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 1"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap || ""}
                        coordinates={layout?.selection2 || {}}
                        onSelectArea={(coordinates) => {
                          setFormValues((v) => {
                            const newLayouts = [...(v.layouts || [])];
                            newLayouts[layoutIdx] = {
                              ...newLayouts[layoutIdx],
                              selection2: coordinates,
                            };
                            return { ...v, layouts: newLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 2"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap || ""}
                        coordinates={layout?.selection3 || {}}
                        onSelectArea={(coordinates) => {
                          setFormValues((v) => {
                            const newLayouts = [...(v.layouts || [])];
                            newLayouts[layoutIdx] = {
                              ...newLayouts[layoutIdx],
                              selection3: coordinates,
                            };
                            return { ...v, layouts: newLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 3"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap || ""}
                        coordinates={layout?.selection4 || {}}
                        onSelectArea={(coordinates) => {
                          setFormValues((v) => {
                            const newLayouts = [...(v.layouts || [])];
                            newLayouts[layoutIdx] = {
                              ...newLayouts[layoutIdx],
                              selection4: coordinates,
                            };
                            return { ...v, layouts: newLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 4"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                  </Flex>
                </div>

                {/* Legend Section */}
                <div className="w-full p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-lg font-semibold text-gray-800">
                      Legend
                    </h4>
                    <button
                      onClick={() => {
                        setFormValues((prev) => {
                          const newLayouts = [...(prev.layouts || [])];
                          newLayouts[layoutIdx] = {
                            ...newLayouts[layoutIdx],
                            legend: [
                              ...(newLayouts[layoutIdx]?.legend || []),
                              { key: "", value: "" },
                            ],
                          };
                          return { ...prev, layouts: newLayouts };
                        });
                      }}
                      className="flex items-center gap-2 px-3 py-1 bg-teal-500 hover:bg-teal-600 text-white rounded-lg transition-colors"
                    >
                      <Icon icon="mdi:plus" width="20" height="20" />
                      Add
                    </button>
                  </div>
                  <div className="space-y-3">
                    {(layout?.legend || []).map((item, legendIdx) => (
                      <div key={legendIdx} className="flex gap-3 items-end">
                        <div className="flex-1">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Key
                          </label>
                          <input
                            type="text"
                            placeholder="Enter key"
                            value={item.key || ""}
                            onChange={(e) => {
                              setFormValues((prev) => {
                                const newLayouts = [...(prev.layouts || [])];
                                const newLegend = [
                                  ...(newLayouts[layoutIdx]?.legend || []),
                                ];
                                newLegend[legendIdx].key = e.target.value;
                                newLayouts[layoutIdx] = {
                                  ...newLayouts[layoutIdx],
                                  legend: newLegend,
                                };
                                return { ...prev, layouts: newLayouts };
                              });
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Value
                          </label>
                          <input
                            type="text"
                            placeholder="Enter value"
                            value={item.value || ""}
                            onChange={(e) => {
                              setFormValues((prev) => {
                                const newLayouts = [...(prev.layouts || [])];
                                const newLegend = [
                                  ...(newLayouts[layoutIdx]?.legend || []),
                                ];
                                newLegend[legendIdx].value = e.target.value;
                                newLayouts[layoutIdx] = {
                                  ...newLayouts[layoutIdx],
                                  legend: newLegend,
                                };
                                return { ...prev, layouts: newLayouts };
                              });
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                          />
                        </div>
                        <button
                          onClick={() => {
                            setFormValues((prev) => {
                              const newLayouts = [...(prev.layouts || [])];
                              const newLegend = (
                                newLayouts[layoutIdx]?.legend || []
                              ).filter((_, i) => i !== legendIdx);
                              newLayouts[layoutIdx] = {
                                ...newLayouts[layoutIdx],
                                legend: newLegend,
                              };
                              return { ...prev, layouts: newLayouts };
                            });
                          }}
                          className="px-3 py-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                        >
                          <Icon icon="mdi:delete" width="20" height="20" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <ViewLayoutBtn
                floorMap={
                  Array.isArray(layout?.floorMap)
                    ? layout?.floorMap?.[0]
                    : layout?.floorMap
                }
                selection1={layout?.selection1}
                selection2={layout?.selection2}
                width={1400}
                layout={layout}
                index={layoutIdx + 1}
              />
              {/* {JSON.stringify(layout)} */}
            </div>
          ))}

          {/* Add Layout & Delete Layout Buttons */}
          <div className="w-full p-4 mt-6 flex justify-center gap-4">
            <Button
              onClick={() => {
                setFormValues((prev) => ({
                  ...prev,
                  layouts: [
                    ...(prev.layouts || []),
                    {
                      floorMap: null,
                      selection1: {},
                      selection2: {},
                      selection3: {},
                      selection4: {},
                      legend: [{ key: "", value: "" }],
                    },
                  ],
                }));
              }}
              colorScheme="teal"
              // className="flex items-center gap-2 px-3 py-2 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-colors"
            >
              <Icon icon="mdi:plus" width="24" height="24" />
              Add New Layout
            </Button>
          </div>
        </Box>
      </Box>
      <Accordion
        my={5}
        defaultIndex={[0]}
        index={accControl}
        onChange={(i) =>
          accControl.includes(i)
            ? setAccControl(accControl.filter((id) => id !== i))
            : setAccControl([...accControl, i])
        }
        allowMultiple
      >
        <div className="bg-[#fafafa] p-4 rounded-xl ">
          <div className="relative flex items-center justify-center mb-4">
            <h2 className="text-center text-xl font-semibold text-teal-600">
              Areas
            </h2>
            <Button
              size="sm"
              colorScheme="teal"
              variant="outline"
              className="!absolute right-0"
              onClick={handleAddArea}
            >
              + Add Area
            </Button>
          </div>

          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={formvalues.areas.map((val) => val.dragId)}
              strategy={verticalListSortingStrategy}
            >
              {formvalues.areas.map((val, idx) => (
                <SortableItem key={val.dragId} id={val.dragId}>
                  <AreaLayout
                    area={val}
                    idx={idx}
                    handleAddArea={() => handleAddAreaBelow(idx)}
                    designStyle={designStyle}
                    handleAccControl={() =>
                      setAccControl(
                        accControl.includes(idx)
                          ? accControl.filter((id) => id !== idx)
                          : [...accControl, idx],
                      )
                    }
                    setFormValues={(key, value) => {
                      setFormValues((prev) => {
                        const updatedAreas = [...prev.areas];
                        updatedAreas[idx] = {
                          ...updatedAreas[idx],
                          [key]: value,
                        };
                        return { ...prev, areas: updatedAreas };
                      });
                    }}
                    companyLogo={formvalues.companyLogo?.[0]}
                    floorMap={(formvalues?.layouts || [])
                      .map((v) => v?.floorMap)
                      .flat()}
                    handleDelete={(idx) => {
                      setFormValues((prev) => {
                        const updatedAreas = prev.areas.filter(
                          (_, i) => i !== idx,
                        );
                        return { ...prev, areas: updatedAreas };
                      });
                    }}
                  />
                </SortableItem>
              ))}
            </SortableContext>
          </DndContext>
        </div>
      </Accordion>
      <div className="sticky bottom-0 bg-white z-[10] py-2 grid grid-cols-2 gap-4">
        {/* <Button
          w={"100%"}
          // mt={2}
          disabled={!chkValidation(true)}
          onClick={() => {
            storeActiveTab && storeActiveTab();
            setData(formvalues);
            nav("/pv/conceptual/testing/" + formvalues.companyName, {
              state: {
                data: {
                  ...formvalues,
                  areas: formvalues.areas.map((v) => ({
                    ...v,
                    internalImages: v.designLibraryImages,
                  })),
                },
              },
            });
          }}
        >
          Show Public View
        </Button> */}
        <TestViewButton
          data={{
            ...formvalues,
            areas: formvalues.areas.map((v) => ({
              ...v,
              internalImages: v.designLibraryImages,
            })),
          }}
          type={"conceptual"}
        />
        <Button
          colorScheme={"teal"}
          width={"100%"}
          // mt={2}
          onClick={handleSubmitForm}
          isLoading={loading}
          loadingText={isEdit ? "Updating..." : "Creating..."}
        >
          Submit
        </Button>
      </div>
      <SaveConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        onUpdate={(notes) => executeSubmit(false)}
        onSaveAsNew={(notes) => executeSubmit(true)}
        currentVersion={formvalues?.version || 1}
        latestVersion={allVersions[0]?.version || formvalues?.version || 1}
      />
    </Box>
  );
}

const AreaLayout = ({
  area,
  idx,
  setFormValues,
  companyLogo,
  floorMap,
  handleDelete,
  designStyle,
  handleAccControl,
  handleAddArea,
}) => {
  const [isActiveImg, setIsActiveImg] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  console.log("form values order", area?.order, floorMap);
  const areaImages = useMemo(() => {
    return area.designLibraryImages;
  }, [area.designLibraryImages]);
  const handleDesignImageChange = (images, isDelete, isCropped = false) => {
    // console.log("Form values, design", images, isDelete, area?.order)
    // return;
    console.log("DESIGN IMADES", images, isDelete);
    if (isDelete) {
      setFormValues(
        "order",
        (area?.order || []).filter((v) => v != `${images.length}0`),
      );
    } else if (images.length - 1 >= 0 && !isCropped) {
      setFormValues("order", [...(area?.order || []), `${images.length - 1}0`]);
    }
    setFormValues("designLibraryImages", images);
    setFormValues("selection1", {});
    setFormValues("selection2", {});
    setFormValues("selection3", {});
    setFormValues("selection4", {});

    // }, []);
  };
  const { pathname } = useLocation();
  const AreaImages = useMemo(() => {
    return getImageUrls(area.areaImage, true);
  }, [area.areaImage, pathname]);
  const handleSwap = (
    from,
    to,
    designImg = [],
    uploadedImg = [],
    currOrder,
  ) => {
    if (!from || !to) return;
    console.log(from, to, designImg, uploadedImg);
    let fromIdx, toIdx;
    if (
      from.includes("static") ||
      from.includes("minio/project-showcase/materials")
    ) {
      fromIdx = designImg.findIndex((v) => v == from) + "0";
    } else {
      fromIdx = uploadedImg.findIndex((v) => v == from) + "1";
    }
    if (
      to.includes("static") ||
      from.includes("minio/project-showcase/materials")
    ) {
      toIdx = designImg.findIndex((v) => v == to) + "0";
    } else {
      toIdx = uploadedImg.findIndex((v) => v == to) + "1";
    }
    let fromOrderIdx = currOrder.findIndex((v) => v == fromIdx);
    let toOrderIdx = currOrder.findIndex((v) => v == toIdx);
    if (fromOrderIdx !== -1 && toOrderIdx !== -1) {
      let arr = [...currOrder];
      let a = arr[fromOrderIdx];
      arr[fromOrderIdx] = arr[toOrderIdx];
      arr[toOrderIdx] = a;
      console.log("CONGO SWAPPED", arr);
      return arr;
    }
    return currOrder;
  };

  // useEffect(()=> {
  //   setFormValues("selection1", {})
  //   setFormValues("selection2", {})

  // },[(area.designLibraryImages || []).length +
  //               (area.areaImage || []).length ==
  //               1 ])

  console.log("AREA++", {
    area,
    idx,
    setFormValues,
    companyLogo,
    floorMap,
    handleDelete,
    designStyle,
    handleAccControl,
  });
  return (
    <AccordionItem>
      <h2 onClick={handleAccControl}>
        <AccordionButton>
          <Box
            as="span"
            flex="1"
            textAlign="left"
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            shadow={"sm"}
          >
            Area {idx + 1} {area?.area ? `(${area.area})` : ""}
            {idx > 0 && <DeleteIcon onClick={() => handleDelete(idx)} />}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Box
          // display={"flex"}
          // justifyContent={"space-between"}
          bgColor={"white"}
          width={"100%"}
          rounded={"md"}
          shadow={"md"}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            // flexBasis={"50%"}
            gap={7}
            padding={3}
          >
            <Flex gap={2}>
              <div className="flex-1">
                <MySelect
                  label={"Area"}
                  placeholder={"Select Area"}
                  options={areaOptions.map((v) => ({
                    label: v.split("-").join(" "),
                    value: v,
                  }))}
                  onChange={(val) => {
                    console.log(val);
                    setFormValues("area", val ? val : "");
                  }}
                  value={area.area}
                  required
                />
              </div>

              <div className="flex-1">
                <MySelect
                  required={true}
                  placeholder={"Select Design Style"}
                  label={"Design Style"}
                  value={area.designStyle}
                  options={designStyle.map((v) => v.name)}
                  onChange={(val) => {
                    setFormValues("designStyle", val);
                    setFormValues("designBg", "background 1");
                  }}
                  isHideCross={true}
                />
              </div>
              <div className="flex-1">
                <MySelect
                  required={true}
                  placeholder={"Select Design Background"}
                  label={"Design Background"}
                  value={area.designBg}
                  options={(
                    designStyle.find((v) => v.name == area?.designStyle)
                      ?.bgArray || []
                  ).map((_, i) => `background ${i + 1}`)}
                  onChange={(val) => setFormValues("designBg", val)}
                  isHideCross={true}
                />
              </div>
            </Flex>
            <div className="flex gap-4">
              <Box flex={1}>
                <ImgUploadDesignLib
                  images={area.designLibraryImages}
                  setImages={handleDesignImageChange}
                  tag={area.area}
                />
              </Box>
              <Box flex={1}>
                <UploadFileStyleTwo
                  key={"uploadExtraImg"}
                  label={"Upload Image (If you needed)"}
                  file={area.areaImage}
                  multiple={true}
                  setFile={(images, _, deleteIdx) => {
                    console.log(
                      "Area Images",
                      images,
                      area.areaImage,
                      area.order,
                      deleteIdx,
                    );
                    // console.log("Form values delete upload", deleteIdx)
                    if (deleteIdx >= 0) {
                      setFormValues(
                        "order",
                        (area?.order || []).filter(
                          (v) => v != `${images.length}1`,
                        ),
                      );
                    } else if (images.length - 1 >= 0) {
                      let appendOrder = [];
                      for (
                        let i = 0;
                        i < images.length - area.areaImage.length;
                        i++
                      ) {
                        appendOrder.push(`${i + area.areaImage.length}1`);
                      }
                      // console.log({appendOrder}, images.length, area.areaImage.length);
                      setFormValues("order", [
                        ...(area?.order || []),
                        ...appendOrder,
                      ]);
                    }
                    setFormValues("areaImage", [...images]);
                    setFormValues("selection1", {});
                    setFormValues("selection2", {});
                    setFormValues("selection3", {});
                    setFormValues("selection4", {});
                  }}
                  isEnableCropping={true}
                  cropData={area?.areaImageSelection || []}
                  setCropData={(cropInfo) => {
                    setFormValues("areaImageSelection", cropInfo);
                  }}
                />
              </Box>
            </div>
            <Box>
              <Flex justify={"space-between"} gap={4} alignItems={"center"}>
                <Box
                  flexBasis={
                    (area.designLibraryImages || []).length +
                      (area.areaImage || []).length ==
                    1
                      ? "33%"
                      : "100%"
                  }
                  h={"100%"}
                >
                  <FloorMapUpload
                    floorMap={
                      area?.selectedKeyPlanIdx !== undefined
                        ? floorMap?.[area?.selectedKeyPlanIdx]
                        : null
                    }
                    coordinates={area.keyPlan}
                    onSelectArea={(coordinates, idx) => {
                      console.log({ coordinates, idx });
                      setFormValues("keyPlan", coordinates);
                      setFormValues("selectedKeyPlanIdx", idx);
                    }}
                    isMultiple={true}
                    selectedKeyPlanIdx={area?.selectedKeyPlanIdx}
                    allFloorMaps={(floorMap || [])?.filter((v) => Boolean(v))}
                  />
                </Box>

                {(area.designLibraryImages || []).length +
                  (area.areaImage || []).length ==
                  1 && (
                  <Flex flexBasis={"66%"} gap={4} wrap={"wrap"}>
                    <Box flexBasis={"48%"}>
                      <FloorMapUpload
                        floorMap={
                          area?.designLibraryImages?.[0] || area.areaImage?.[0]
                        }
                        onSelectArea={(coordinates) => {
                          setFormValues("selection1", coordinates);
                        }}
                        coordinates={area?.selection1 || {}}
                        area={area}
                        isImageAreaSelection={true}
                        heading={"Select area image selection 1"}
                        btnText={"Select focus area"}
                        isLargeArea={true}
                      />
                    </Box>
                    <Box flexBasis={"48%"}>
                      <FloorMapUpload
                        floorMap={
                          area?.designLibraryImages?.[0] || area.areaImage?.[0]
                        }
                        onSelectArea={(coordinates) => {
                          setFormValues("selection2", coordinates);
                        }}
                        coordinates={area?.selection2 || {}}
                        area={area}
                        isImageAreaSelection={true}
                        heading={"Select area image selection 2"}
                        btnText={"Select focus area"}
                        isLargeArea={true}
                      />
                    </Box>
                    <Box flexBasis={"48%"}>
                      <FloorMapUpload
                        floorMap={
                          area?.designLibraryImages?.[0] || area.areaImage?.[0]
                        }
                        onSelectArea={(coordinates) => {
                          setFormValues("selection3", coordinates);
                        }}
                        coordinates={area?.selection3 || {}}
                        area={area}
                        isImageAreaSelection={true}
                        heading={"Select area image selection 3"}
                        btnText={"Select focus area"}
                        isLargeArea={true}
                      />
                    </Box>
                    <Box flexBasis={"48%"}>
                      <FloorMapUpload
                        floorMap={
                          area?.designLibraryImages?.[0] || area.areaImage?.[0]
                        }
                        onSelectArea={(coordinates) => {
                          setFormValues("selection4", coordinates);
                        }}
                        coordinates={area?.selection4 || {}}
                        area={area}
                        isImageAreaSelection={true}
                        heading={"Select area image selection 4"}
                        btnText={"Select focus area"}
                        isLargeArea={true}
                      />
                    </Box>
                  </Flex>
                )}
              </Flex>
            </Box>
          </Box>
          {isPreview && (
            <PopupWrapper
              // heading={"Area Preview"}
              width={"max-w-[1400px]"}
              maxHeight={"max-h-[95dvh]"}
              isOverflow
              padding={1}
              bgColor={"bg-white"}
              onClose={() => setIsPreview(false)}
            >
              <Box
                flexBasis={"50%"}
                // p={3}
                w={"100%"}
                h={"100%"}
                // overflowY={"auto"}
              >
                <ImgGrid
                  // isPublicView={true}
                  images={[
                    ...area.designLibraryImages,
                    ...AreaImages.map((i, idx) => {
                      if (
                        area?.areaImageSelection &&
                        Array.isArray(area?.areaImageSelection) &&
                        area?.areaImageSelection?.[idx]
                      ) {
                        // console.log({selection : v?.area?.areaImageSelection?.[idx], image: i, idx, newUrl : `${i}${i?.includes("?") ? "&" : "?"}crop=${JSON.stringify(v?.area?.areaImageSelection?.[idx] || {})}`})
                        return `${i}${i?.includes("?") ? "&" : "?"}crop=${JSON.stringify(area?.areaImageSelection?.[idx] || {})}`;
                      } else {
                        return i;
                      }
                    }),
                  ]}
                  order={area.order}
                  areaName={area.area}
                  companyLogo={getImageUrls([companyLogo], true, true)?.[0]}
                  coordinates={area.keyPlan}
                  floorMap={
                    area?.selectedKeyPlanIdx !== undefined
                      ? floorMap?.[area?.selectedKeyPlanIdx]
                      : null
                  }
                  selectedDesignStyle={area.designStyle}
                  selectedDesignBg={getDesignBgImage(
                    area.designStyle,
                    area.designBg,
                  )}
                  isActiveImg={isActiveImg}
                  selection1={area.selection1}
                  selection2={area.selection2}
                  selection3={area.selection3}
                  selection4={area.selection4}
                  handleActiveImg={(img) => {
                    console.log(img);
                    if (img == isActiveImg) setIsActiveImg(null);
                    else setIsActiveImg(img);
                  }}
                />

                <div className="p-3">
                  {isActiveImg && (
                    <div className="w-[36vw] border-2  mt-4 overflow-x-scroll flex items-center gap-2">
                      {[...area.designLibraryImages, ...AreaImages]
                        .filter((i) => i != isActiveImg)
                        .map((i) => (
                          // <div>
                          <>
                            {/* <Img
                      onClick={() => {
                        let updatedOrder = handleSwap(
                          isActiveImg,
                          i,
                          area.designLibraryImages,
                          AreaImages,
                          area.order
                        );
                        setIsActiveImg(null);
                        setFormValues("order", updatedOrder);
                      }}
                      src={i}
                      className={"w-36 h-36 min-w-36 min-h-36 object-cover"}
                      /> */}
                            <div className="w-36 h-36 min-w-36 min-h-36">
                              <ActiveImg
                                isPdfView={false}
                                src={i}
                                handleActiveImg={() => {
                                  let updatedOrder = handleSwap(
                                    isActiveImg,
                                    i,
                                    area.designLibraryImages,
                                    AreaImages,
                                    area.order,
                                  );
                                  setIsActiveImg(null);
                                  setFormValues("order", updatedOrder);
                                }}
                                isActive={false}
                              />
                            </div>
                          </>
                          // </div>
                        ))}
                    </div>
                  )}
                  <p className="text-xs mt-4 text-gray-600 italic">
                    NOTE: Click on image to swap it{" "}
                  </p>
                </div>
              </Box>
            </PopupWrapper>
          )}
          <div className="px-3 py-2 grid grid-cols-2 gap-3">
            <Button
              disabled={
                !area?.area ||
                [...area.designLibraryImages, ...AreaImages].length == 0
              }
              onClick={() => setIsPreview(true)}
              w={"100%"}
              colorScheme="teal"
            >{`View Area ${idx + 1} Preview`}</Button>
            <Button
              w={"100%"}
              colorScheme="teal"
              variant={"outline"}
              onClick={handleAddArea}
            >
              Add Area
            </Button>
          </div>
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default PlanLayout;
